/**
 * Created by Jerker Nord on 2023-10-16.
 */
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../../core/winpresentation/SimplePresentationRunner";
import {Loner} from "../../../Loner";
import {LonerGameMode} from "../../../server/LonerGameMode";
import {LonerSound} from "../../../sound/LonerSound";
import {gsap} from "gsap";
import {LonerPinTheWinResultPresentation} from "./LonerPinTheWinResultPresentation";

export class LonerPinTheWinOutroPresentation implements SimplePresentation {

    protected _controller: SimplePresentationRunnerController;

    public shouldRun(): boolean {
        return Loner.model.data.mode == LonerGameMode.FEATURE_PIN_THE_WIN
            && Loner.model.data.nextMode == LonerGameMode.NORMAL
            && !Loner.model.data.brokeTheBank;
    }

    public start(controller: SimplePresentationRunnerController): void {
        const mainTL: gsap.core.Timeline = gsap.timeline();
        const amount: number = Loner.model.accumulatedRoundWin;
        const countDuration: number = 1.871;
        let aborted: boolean = false;
        const isWinBelowStake: boolean = Loner.isWinBelowStake();

        mainTL.add(() => Loner.foregroundView.clearAnimationTrack(2));
        mainTL.add(gsap.timeline({delay: 0.5}));
        mainTL.add(Loner.pinTheWinOutroView.showOutro(() => this.fsIntroClosedCallback(controller, isWinBelowStake)));
        mainTL.add(() => controller.setSkipCallback(() => {
            aborted = true;
            mainTL.seek("end", false);
        }));
        mainTL.add(Loner.pinTheWinOutroView.getCountUp(amount, countDuration, isWinBelowStake));
        mainTL.add(() => {
            LonerPinTheWinResultPresentation.setSubTlAddedToMainTlFlag(false);
            Loner.soundPlayer.playSound(LonerSound.PTW_OUTRO_LOOP, 1, Number.MAX_VALUE);
        })
        mainTL.addLabel("end");
        mainTL.add(() => controller.setSkipCallback());
        mainTL.add(Loner.pinTheWinOutroView.showButton());
    }

    private fsIntroClosedCallback(controller: SimplePresentationRunnerController, isWinBelowStake: boolean): void {
        const tl: gsap.core.Timeline = gsap.timeline({onComplete: () => controller.finish()});
        tl.add(() => {
            Loner.allReelView.enableAllViews();
            Loner.logoView.show();
            Loner.tvMessageView.show();
        });
        tl.add([
            Loner.pinTheWinOutroView.hideOutro(isWinBelowStake)
        ]);
    }
}